// extracted by mini-css-extract-plugin
export default {"container":"Homepage_container__pt4WM","leftsection":"Homepage_leftsection__OupE6","rightsection":"Homepage_rightsection__1MFKO"};